import {
  Checkbox,
  checkboxStates,
  Input,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import DatePicker from "components/DatePicker";
import ListInput from "components/ListInput";
import { Search, X } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchSharepointSites,
  searchSharepoint,
} from "../../../../../slices/sharepoint/actions";
import { selectSharepoint } from "../../../../../slices/sharepoint/selectors";
import {
  resetSharepointSearch,
  setIsSearchOpen,
  setSearchFilters,
  setSearchValue,
} from "../../../../../slices/sharepoint/sharepointSlice";
import { isSearchDisabled } from "./helpers";

const ICON_COLOR = "var(--color-middle-black)";

const SharePointSearch = () => {
  const dispatch = useDispatch();

  const { search } = useSelector(selectSharepoint);
  const { value, filters } = search;
  const { categories, from, to, author, tags } = filters;

  const handleCategoryChange = (category) => {
    const newCategories = categories.includes(category)
      ? categories.filter((cat) => cat !== category)
      : [...categories, category];

    dispatch(setSearchFilters({ categories: newCategories }));
  };

  return (
    <div className="sharepoint_search__container">
      <div className="sharepoint_panel__header">
        <div className="sharepoint_search__header_content">
          <Search
            size={16}
            strokeWidth={2}
            color={ICON_COLOR}
            className="sharepoint_search__search_icon"
          />

          <strong>Search</strong>
        </div>
        <NewButton
          classes="sharepoint_panel__header__button"
          variant={NewButtonVariant.l4}
          data-testid={"close-search-button"}
          onClick={() => {
            dispatch(resetSharepointSearch());
            dispatch(fetchSharepointSites());
          }}
          leftIcon={<X size={16} strokeWidth={2} color={ICON_COLOR} />}
        />
      </div>
      <div className="sharepoint_search__content">
        <div className="sharepoint_search__search_section">
          <Input
            placeholder="Type to search"
            value={value}
            onChange={(event) => dispatch(setSearchValue(event))}
          />

          <div className="sharepoint_search__category_options">
            <div className="sharepoint_search__category_option">
              <label
                className="sharepoint_search__category_label"
                htmlFor="sites"
              >
                Sites
              </label>
              <Checkbox
                id="sites"
                state={
                  categories.includes("sites")
                    ? checkboxStates.checked
                    : checkboxStates.empty
                }
                handleChange={() => handleCategoryChange("sites")}
              />
            </div>
            <div className="sharepoint_search__category_option">
              <label
                className="sharepoint_search__category_label"
                htmlFor="folders"
              >
                Folders
              </label>
              <Checkbox
                id="folders"
                state={
                  categories.includes("folders")
                    ? checkboxStates.checked
                    : checkboxStates.empty
                }
                handleChange={() => handleCategoryChange("folders")}
              />
            </div>
            <div className="sharepoint_search__category_option">
              <label
                className="sharepoint_search__category_label"
                htmlFor="files"
              >
                Documents
              </label>
              <Checkbox
                id="files"
                state={
                  categories.includes("files")
                    ? checkboxStates.checked
                    : checkboxStates.empty
                }
                handleChange={() => handleCategoryChange("files")}
              />
            </div>
          </div>
        </div>
        <div className="sharepoint_search__date_section">
          <div className="sharepoint_search__date_picker_container">
            <DatePicker
              className="sharepoint_search__date_picker"
              label="From"
              id="from"
              value={from ? from.toISOString().split("T")[0] : ""}
              onChange={(e) => {
                dispatch(
                  setSearchFilters({ from: e === "" ? "" : new Date(e) })
                );
              }}
            />

            <DatePicker
              className="sharepoint_search__date_picker"
              label="To"
              id="to"
              value={to ? to.toISOString().split("T")[0] : ""}
              onChange={(e) =>
                dispatch(setSearchFilters({ to: e === "" ? "" : new Date(e) }))
              }
            />
          </div>
          <Input
            placeholder="Author Name"
            value={author}
            onChange={(event) => {
              dispatch(setSearchFilters({ author: event }));
            }}
          />
        </div>
        <div className="sharepoint_search__list_input_container">
          <label htmlFor="sharepoint-tags-input">Tags</label>
          <ListInput
            content={tags}
            setContent={(newTags) =>
              dispatch(setSearchFilters({ tags: newTags }))
            }
            disabled={false}
            inputId="sharepoint-tags-input"
          />
        </div>
        <div className="sharepoint_search__button_container">
          <NewButton
            variant={NewButtonVariant.l1}
            disabled={isSearchDisabled(value, filters)}
            onClick={() => {
              dispatch(searchSharepoint());
              dispatch(setIsSearchOpen(false));
            }}
          >
            Search
          </NewButton>
        </div>
      </div>
    </div>
  );
};

export default SharePointSearch;
